/* eslint-disable no-unused-expressions */
import React, { Component } from 'react'
import {
  Row, Col, Spinner, Button,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Label, FormGroup, FormFeedback, Input,
} from 'reactstrap'
import jsonp from 'jsonp'
import { v4 as uuid } from 'uuid'
import MaskedInput from '../Template/Input/MaskedInput'
import Select from '../Template/Input/Select'
import AsyncSelect from '../Template/Input/AsyncSelect'
import AsyncCreatableSelect from '../Template/Input/AsyncCreatableSelect'
import oikosApi from '../../services/oikos'
import { notifyError } from '../../utils/notify'

const fields = [
  {
    name: 'pj_cnpj',
    required: 1,
  },
  {
    name: 'pj_nomefanta',
    required: 1,
  },
  {
    name: 'pj_razaosocial',
    required: 1,
  },
  {
    name: 'areaAtua_id',
    required: 0,
  },
  {
    name: 'pais_id',
    required: 1,
  },
  {
    name: 'uf_id',
    required: 0,
  },
  {
    name: 'mun_id',
    required: 0,
  },
  {
    name: 'pj_cep',
    required: 0,
  },
  {
    name: 'pj_endLogr',
    required: 1,
  },
  {
    name: 'pj_endNum',
    required: 1,
  },
  {
    name: 'pj_endCompl',
    required: 1,
  },
  {
    name: 'pj_site',
    required: 1,
  },
  {
    name: 'pj_emailPrin',
    required: 1,
  },
  {
    name: 'pj_telPrin',
    required: 1,
  },
]

export default class NewLegalEntity extends Component {
  constructor(props) {
    super(props)
    this.state = {
      stakeholders: [
        {
          id: uuid(),
        },
      ],
      data: {},
      formErrors: {},
      handleFormSubmitIsLoading: false,

      getCnpjInfoIsLoading: false,

      getCitiesIsLoading: false,
      cities: [],

      getStatesIsLoading: false,
      states: [],

      getCountriesIsLoading: false,
      countries: [],
    }
  }

  componentDidMount() {
    this.getCities()
    this.getStates()
    this.getCountries()
  }

  getCities = async () => {
    try {
      this.setState({ getCitiesIsLoading: true })

      const action = 'get'
      const table = 'mun'
      const res = await oikosApi.get('/', { action, table })
      console.tron.log('res getCities', res)

      this.setState({ getCitiesIsLoading: false, cities: res.data })
    } catch (err) {
      console.tron.log('Erro ao buscar municípios.', err.toString())
      notifyError(`Erro ao buscar municípios. ${err.toString()}`)
      this.setState({
        getCitiesIsLoading: false,
        cities: [],
      })
    }
  }

  getStates = async () => {
    try {
      this.setState({ getStatesIsLoading: true })

      const action = 'get'
      const table = 'uf'
      const res = await oikosApi.get('/', { action, table })
      console.tron.log('res getStates', res)

      this.setState({ getStatesIsLoading: false, states: res.data })
    } catch (err) {
      console.tron.log('Erro ao buscar estados.', err.toString())
      notifyError(`Erro ao buscar estados. ${err.toString()}`)
      this.setState({
        getStatesIsLoading: false,
        states: [],
      })
    }
  }

  getCountries = async () => {
    try {
      this.setState({ getCountriesIsLoading: true })

      const action = 'get'
      const table = 'pais'
      const res = await oikosApi.get('/', { action, table })
      console.tron.log('res getCountries', res)

      this.setState({ getCountriesIsLoading: false, countries: res.data })
    } catch (err) {
      console.tron.log('Erro ao buscar países.', err.data)
      notifyError(`Erro ao buscar países. ${err.data}`)
      this.setState({
        getCountriesIsLoading: false,
        countries: [],
      })
    }
  }

  getCnpjInfo = async () => {
    this.setState({ getCnpjInfoIsLoading: true })

    const { data, states, cities } = this.state
    const cnpj = data.pj_cnpj

    jsonp(`https://www.receitaws.com.br/v1/cnpj/${cnpj}`, null, (err, res) => {
      if (err) {
        console.tron.log('Erro ao buscar informações do CNPJ.')
        notifyError(`Erro ao buscar informações do CNPJ. ${err.message}`)
        this.setState({ getCnpjInfoIsLoading: false })
      } else {
        console.tron.log('res getCnpjInfo', res)
        if (res.status === 'ERROR') {
          console.tron.log(res.message)
          notifyError(res.message)
          this.setState({ getCnpjInfoIsLoading: false })
        } else {
          /* notifySuccess('Informações recuperadas com sucesso.') */
          this.setState(prevState => ({
            getCnpjInfoIsLoading: false,
            data: {
              ...prevState.data,
              pais_id: {
                pais_id: 30,
                pais_nome: 'Brasil',
              },
              pj_nomefanta: res.fantasia || undefined,
              pj_razaosocial: res.nome || undefined,
              pj_cep: res.cep ? res.cep.replace(/\D/g, '') : undefined,
              pj_endLogr: res.logradouro || undefined,
              pj_endNum: res.numero || undefined,
              pj_endCompl: res.complemento || undefined,
              pj_emailPrin: res.email || undefined,
              pj_telPrin: res.telefone || undefined,
              uf_id: states?.find(state => state.uf_sigla === res.uf) || undefined,
              mun_id: cities?.find(city => city?.mun_nome?.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') === res?.municipio?.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) || undefined,
            },
          }))
        }
      }
    })
  }

  validateForm = () => {
    const { data } = this.state
    const formErrors = {}
    let isValid = true

    fields.forEach(field => {
      if (field.required === 1 && !data[field.name]) {
        isValid = false
        formErrors[field.name] = 'Obrigatório'
      }
    })

    this.setState({ formErrors })
    return isValid
  }

  handleSubmit = async () => {
    try {
      this.setState({ handleFormSubmitIsLoading: true })

      let { data } = this.state
      const { stakeholders } = this.state

      data = Object.fromEntries(Object.entries(data).filter((...[, v]) => v !== null))

      const body = {
        table: 'pj',
        action: 'insert',
        data: {
          ...data,
          areaAtua_id: data.areaAtua_id ? data.areaAtua_id.areaAtua_id : undefined,
          pjTp_id: data.pjTp_id ? data.pjTp_id.pjTp_id : undefined,
          pais_id: data.pais_id ? data.pais_id.pais_id : undefined,
          uf_id: data.uf_id ? data.uf_id.uf_id : undefined,
          mun_id: data.mun_id ? data.mun_id.mun_id : undefined,
          pj_contato: (stakeholders?.length > 1 || (stakeholders?.length === 1 && stakeholders[0].pf_nomeExibicao))
            ? (
              stakeholders.map(stakeholder => {
                if (stakeholder && stakeholder.pf_nomeExibicao) {
                  return ({
                    nome: stakeholder?.pf_nomeExibicao?.pf_nomeExibicao,
                    papel: stakeholder?.papel_id?.papel_id,
                    email: stakeholder?.email,
                    telefone: stakeholder?.phone,
                  })
                }

                return undefined
              })
            )
            : undefined,
        },
      }

      console.tron.log('body pj insert', body)

      const res = await oikosApi.post('/', body)

      console.tron.log('res pj insert', res)

      this.setState({
        handleFormSubmitIsLoading: false,
        data: {},
        stakeholders: [
          {
            id: uuid(),
          },
        ],
      })

      this.props.toggle(res.data[0].pj_id)
    } catch (e) {
      this.setState({ handleFormSubmitIsLoading: false })
      notifyError(`Não foi possível adicionar o registro. ${e.data}`)
      console.tron.log('Não foi possível adicionar o registro.', e)
    }
  }

  render() {
    const { centered, isOpen, toggle } = this.props

    const {
      stakeholders, data, formErrors,
      getCnpjInfoIsLoading, handleFormSubmitIsLoading,
      getCitiesIsLoading, cities,
      getStatesIsLoading, states,
      getCountriesIsLoading, countries,
    } = this.state

    console.tron.log('this.state', this.state)

    return (
      <Modal
        centered={centered}
        isOpen={isOpen}
        toggle={false}
        size="lg"
      >
        <ModalHeader toggle={toggle}>
          Adicionar contratante
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <h6>
                Geral
              </h6>
            </Col>
          </Row>

          <Row>
            <Col>
              <hr style={{ marginTop: 0, paddingTop: 0 }} />
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6} lg={4}>
              <FormGroup>
                <Label>
                  CNPJ
                </Label>

                <div className="d-flex">
                  <MaskedInput
                    unmask
                    invalid={formErrors.pj_cnpj}
                    mask="00.000.000/0000-00"
                    lazy={false}
                    value={data.pj_cnpj}
                    onAccept={(value) => this.setState(prevState => ({
                      data: {
                        ...prevState.data,
                        pj_cnpj: value,
                      },
                      formErrors: {
                        ...prevState.formErrors,
                        pj_cnpj: undefined,
                      },
                    }))}
                  />

                  <Button
                    /* outline */
                    color="light"
                    size="sm"
                    className="ml-2"
                    onClick={() => this.getCnpjInfo()}
                    disabled={!data.pj_cnpj || getCnpjInfoIsLoading}
                    title="Consultar informações"
                  >
                    {
                      getCnpjInfoIsLoading
                        ? <Spinner size="sm" />
                        : <i className="ri-information-line font-size-17 align-middle" />
                    }
                  </Button>
                </div>

                <FormFeedback className={`d-block ${formErrors.pj_cnpj ? 'visible' : 'invisible'}`}>
                  {formErrors.pj_cnpj}
                </FormFeedback>
              </FormGroup>
            </Col>

            <Col xs={12} sm={6} lg={4}>
              <FormGroup>
                <Label>
                  Área de atuação
                </Label>

                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  isSearchable={false}
                  isClearable
                  isMulti={false}
                  getOptionValue={option => option.areaAtua_id}
                  getOptionLabel={option => option.areaAtua_area}
                  value={data.areaAtua_id}
                  styles={{
                    control: styles => ({
                      ...styles,
                      borderColor: formErrors.areaAtua_id ? '#ff3d60' : styles.borderColor,
                      '&:hover': {
                        borderColor: formErrors.areaAtua_id ? '#ff3d60' : styles['&:hover'].borderColor,
                      },
                    }),
                  }}
                  loadOptions={async () => {
                    try {
                      const res = await oikosApi.get('/', {
                        action: 'get',
                        table: 'areaAtua',
                      })

                      if (data.areaAtua_id !== undefined) {
                        this.setState(prevState => ({
                          data: {
                            ...prevState.data,
                            areaAtua_id: res.data.find(i => i.areaAtua_id === data.areaAtua_id),
                          },
                        }))
                      }

                      return res.data
                    } catch (e) {
                      return notifyError(e)
                    }
                  }}
                  onChange={e => this.setState(prevState => ({
                    data: {
                      ...prevState.data,
                      areaAtua_id: e,
                    },
                    formErrors: {
                      ...prevState.formErrors,
                      areaAtua_id: undefined,
                    },
                  }))}
                />

                <FormFeedback className={`d-block ${formErrors.areaAtua_id ? 'visible' : 'invisible'}`}>
                  {formErrors.areaAtua_id}
                </FormFeedback>
              </FormGroup>
            </Col>

            <Col xs={12} sm={6} lg={4}>
              <FormGroup>
                <Label>
                  Tipo
                </Label>

                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  isSearchable={false}
                  isClearable
                  isMulti={false}
                  getOptionValue={option => option.pjTp_id}
                  getOptionLabel={option => option.pjTp_desc}
                  value={data.pjTp_id}
                  styles={{
                    control: styles => ({
                      ...styles,
                      borderColor: formErrors.pjTp_id ? '#ff3d60' : styles.borderColor,
                      '&:hover': {
                        borderColor: formErrors.pjTp_id ? '#ff3d60' : styles['&:hover'].borderColor,
                      },
                    }),
                  }}
                  loadOptions={async () => {
                    try {
                      const res = await oikosApi.get('/', {
                        action: 'get',
                        table: 'pjTp',
                      })

                      if (data.pjTp_id !== undefined) {
                        this.setState(prevState => ({
                          data: {
                            ...prevState.data,
                            pjTp_id: res.data.find(i => i.pjTp_id === data.pjTp_id),
                          },
                        }))
                      }

                      return res.data
                    } catch (e) {
                      return notifyError(e)
                    }
                  }}
                  onChange={e => this.setState(prevState => ({
                    data: {
                      ...prevState.data,
                      pjTp_id: e,
                    },
                    formErrors: {
                      ...prevState.formErrors,
                      pjTp_id: undefined,
                    },
                  }))}
                />

                <FormFeedback className={`d-block ${formErrors.pjTp_id ? 'visible' : 'invisible'}`}>
                  {formErrors.pjTp_id}
                </FormFeedback>
              </FormGroup>
            </Col>

            <Col xs={12} sm={6} lg={6}>
              <FormGroup>
                <Label>
                  Nome fantasia
                </Label>

                <Input
                  invalid={formErrors.pj_nomefanta}
                  value={data.pj_nomefanta}
                  onChange={e => this.setState({
                    data: {
                      ...data,
                      pj_nomefanta: e?.target?.value,
                    },
                    formErrors: {
                      ...formErrors,
                      pj_nomefanta: undefined,
                    },
                  })}
                />

                <FormFeedback className={`d-block ${formErrors.pj_nomefanta ? 'visible' : 'invisible'}`}>
                  {formErrors.pj_nomefanta}
                </FormFeedback>
              </FormGroup>
            </Col>

            <Col xs={12} sm={6} lg={6}>
              <FormGroup>
                <Label>
                  Razão social
                </Label>

                <Input
                  invalid={formErrors.pj_razaosocial}
                  value={data.pj_razaosocial}
                  onChange={e => this.setState({
                    data: {
                      ...data,
                      pj_razaosocial: e?.target?.value,
                    },
                    formErrors: {
                      ...formErrors,
                      pj_razaosocial: undefined,
                    },
                  })}
                />

                <FormFeedback className={`d-block ${formErrors.pj_razaosocial ? 'visible' : 'invisible'}`}>
                  {formErrors.pj_razaosocial}
                </FormFeedback>
              </FormGroup>
            </Col>
          </Row>

          <Row className="mt-1">
            <Col>
              <h6>
                Endereço
              </h6>
            </Col>
          </Row>

          <Row>
            <Col>
              <hr style={{ marginTop: 0, paddingTop: 0 }} />
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6} lg={3}>
              <FormGroup>
                <Label>
                  País
                </Label>

                <Select
                  isSearchable
                  isClearable
                  isLoading={getCountriesIsLoading || getStatesIsLoading || getCnpjInfoIsLoading}
                  isMulti={false}
                  isDisabled={getCountriesIsLoading || getStatesIsLoading || getCnpjInfoIsLoading}
                  getOptionValue={option => option.pais_id}
                  getOptionLabel={option => option.pais_nome}
                  value={data.pais_id}
                  options={countries.sort((a, b) => ((a.pais_nome > b.pais_nome) ? 1 : ((b.pais_nome > a.pais_nome) ? -1 : 0)))}
                  styles={{
                    control: styles => ({
                      ...styles,
                      borderColor: formErrors.uf_id ? '#ff3d60' : styles.borderColor,
                      '&:hover': {
                        borderColor: formErrors.uf_id ? '#ff3d60' : styles['&:hover'].borderColor,
                      },
                    }),
                  }}
                  onChange={e => this.setState(prevState => ({
                    data: {
                      ...prevState.data,
                      pais_id: e,
                      mun_id: e?.pais_nome === 'Brasil' ? prevState.data.mun_id : null,
                      uf_id: e?.pais_nome === 'Brasil' ? prevState.data.uf_id : null,
                      pj_cep: e?.pais_nome === 'Brasil' ? prevState.data.pj_cep : null,
                    },
                    formErrors: {
                      ...prevState.formErrors,
                      pais_id: undefined,
                    },
                  }))}
                />

                <FormFeedback className={`d-block ${formErrors.pais_id ? 'visible' : 'invisible'}`}>
                  {formErrors.pais_id}
                </FormFeedback>
              </FormGroup>
            </Col>

            <Col xs={12} sm={6} lg={3}>
              <FormGroup>
                <Label>
                  UF
                </Label>

                <Select
                  isSearchable
                  isClearable
                  isLoading={getCountriesIsLoading || getStatesIsLoading || getCnpjInfoIsLoading}
                  isMulti={false}
                  isDisabled={!data.pais_id || data.pais_id.pais_nome !== 'Brasil' || getCountriesIsLoading || getStatesIsLoading || getCnpjInfoIsLoading}
                  getOptionValue={option => option.uf_id}
                  getOptionLabel={option => option.uf_nome}
                  value={data.uf_id}
                  options={states.sort((a, b) => ((a.uf_nome > b.uf_nome) ? 1 : ((b.uf_nome > a.uf_nome) ? -1 : 0)))}
                  styles={{
                    control: styles => ({
                      ...styles,
                      borderColor: formErrors.uf_id ? '#ff3d60' : styles.borderColor,
                      '&:hover': {
                        borderColor: formErrors.uf_id ? '#ff3d60' : styles['&:hover'].borderColor,
                      },
                    }),
                  }}
                  onChange={e => this.setState(prevState => ({
                    data: {
                      ...prevState.data,
                      uf_id: e,
                      mun_id: null,
                    },
                    formErrors: {
                      ...prevState.formErrors,
                      uf_id: undefined,
                    },
                  }))}
                />

                <FormFeedback className={`d-block ${formErrors.uf_id ? 'visible' : 'invisible'}`}>
                  {formErrors.uf_id}
                </FormFeedback>
              </FormGroup>
            </Col>

            <Col xs={12} sm={6} lg={4}>
              <FormGroup>
                <Label>
                  Município
                </Label>

                <Select
                  isSearchable
                  isClearable
                  isLoading={getCountriesIsLoading || getStatesIsLoading || getCitiesIsLoading || getCnpjInfoIsLoading}
                  isMulti={false}
                  isDisabled={!data.pais_id || data.pais_id.pais_nome !== 'Brasil' || getCountriesIsLoading || getStatesIsLoading || getCnpjInfoIsLoading || !data.uf_id}
                  getOptionValue={option => option.mun_id}
                  getOptionLabel={option => option.mun_nome}
                  value={data.mun_id}
                  options={
                    cities
                      ?.filter(city => city.uf_IBGECod === data?.uf_id?.uf_IBGECod)
                      ?.sort((a, b) => ((a.mun_nome > b.mun_nome) ? 1 : ((b.mun_nome > a.mun_nome) ? -1 : 0)))
                  }
                  styles={{
                    control: styles => ({
                      ...styles,
                      borderColor: formErrors.uf_id ? '#ff3d60' : styles.borderColor,
                      '&:hover': {
                        borderColor: formErrors.uf_id ? '#ff3d60' : styles['&:hover'].borderColor,
                      },
                    }),
                  }}
                  onChange={e => this.setState(prevState => ({
                    data: {
                      ...prevState.data,
                      mun_id: e,
                    },
                    formErrors: {
                      ...prevState.formErrors,
                      mun_id: undefined,
                    },
                  }))}
                />

                <FormFeedback className={`d-block ${formErrors.mun_id ? 'visible' : 'invisible'}`}>
                  {formErrors.mun_id}
                </FormFeedback>
              </FormGroup>
            </Col>

            <Col xs={12} sm={6} lg={2}>
              <FormGroup>
                <Label>
                  CEP
                </Label>

                <MaskedInput
                  unmask
                  invalid={formErrors.pj_cep}
                  mask="00000-000"
                  lazy={false}
                  value={data.pj_cep}
                  disabled={!data.pais_id || data.pais_id.pais_nome !== 'Brasil'}
                  onAccept={(value) => this.setState(prevState => ({
                    data: {
                      ...prevState.data,
                      pj_cep: value,
                    },
                    formErrors: {
                      ...prevState.formErrors,
                      pj_cep: undefined,
                    },
                  }))}
                />
              </FormGroup>

              <FormFeedback className={`d-block ${formErrors.pj_cep ? 'visible' : 'invisible'}`}>
                {formErrors.pj_cep}
              </FormFeedback>
            </Col>

            <Col xs={12} sm={6} lg={8}>
              <FormGroup>
                <Label>
                  Logradouro
                </Label>

                <Input
                  invalid={formErrors.pj_endLogr}
                  value={data.pj_endLogr}
                  onChange={e => this.setState({
                    data: {
                      ...data,
                      pj_endLogr: e?.target?.value,
                    },
                    formErrors: {
                      ...formErrors,
                      pj_endLogr: undefined,
                    },
                  })}
                />

                <FormFeedback className={`d-block ${formErrors.pj_endLogr ? 'visible' : 'invisible'}`}>
                  {formErrors.pj_endLogr}
                </FormFeedback>
              </FormGroup>
            </Col>

            <Col xs={12} sm={6} lg={2}>
              <FormGroup>
                <Label>
                  Número
                </Label>

                <Input
                  type="number"
                  min={0}
                  invalid={formErrors.pj_endNum}
                  value={data.pj_endNum}
                  onChange={e => this.setState({
                    data: {
                      ...data,
                      pj_endNum: e?.target?.value,
                    },
                    formErrors: {
                      ...formErrors,
                      pj_endNum: undefined,
                    },
                  })}
                />
              </FormGroup>

              <FormFeedback className={`d-block ${formErrors.pj_endNum ? 'visible' : 'invisible'}`}>
                {formErrors.pj_endNum}
              </FormFeedback>
            </Col>

            <Col xs={12} sm={6} lg={2}>
              <FormGroup>
                <Label>
                  Complemento
                </Label>

                <Input
                  invalid={formErrors.pj_endCompl}
                  value={data.pj_endCompl}
                  onChange={e => this.setState({
                    data: {
                      ...data,
                      pj_endCompl: e?.target?.value,
                    },
                    formErrors: {
                      ...formErrors,
                      pj_endCompl: undefined,
                    },
                  })}
                />

                <FormFeedback className={`d-block ${formErrors.pj_endCompl ? 'visible' : 'invisible'}`}>
                  {formErrors.pj_endCompl}
                </FormFeedback>
              </FormGroup>
            </Col>
          </Row>

          <Row className="mt-1">
            <Col>
              <h6>
                Contato institucional
              </h6>
            </Col>
          </Row>

          <Row>
            <Col>
              <hr style={{ marginTop: 0, paddingTop: 0 }} />
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6} lg={5}>
              <FormGroup>
                <Label>
                  Site
                </Label>

                <Input
                  invalid={formErrors.pj_site}
                  value={data.pj_site}
                  onChange={e => this.setState({
                    data: {
                      ...data,
                      pj_site: e?.target?.value,
                    },
                    formErrors: {
                      ...formErrors,
                      pj_site: undefined,
                    },
                  })}
                />

                <FormFeedback className={`d-block ${formErrors.pj_site ? 'visible' : 'invisible'}`}>
                  {formErrors.pj_site}
                </FormFeedback>
              </FormGroup>
            </Col>

            <Col xs={12} sm={6} lg={4}>
              <FormGroup>
                <Label>
                  E-mail
                </Label>

                <Input
                  invalid={formErrors.pj_emailPrin}
                  value={data.pj_emailPrin}
                  onChange={e => this.setState({
                    data: {
                      ...data,
                      pj_emailPrin: e?.target?.value,
                    },
                    formErrors: {
                      ...formErrors,
                      pj_emailPrin: undefined,
                    },
                  })}
                />

                <FormFeedback className={`d-block ${formErrors.pj_emailPrin ? 'visible' : 'invisible'}`}>
                  {formErrors.pj_emailPrin}
                </FormFeedback>
              </FormGroup>
            </Col>

            <Col xs={12} sm={6} lg={3}>
              <FormGroup>
                <Label>
                  Telefone
                </Label>

                <MaskedInput
                  unmask
                  mask="(00) 00000-0000"
                  lazy={false}
                  value={data.pj_telPrin}
                  onAccept={value => this.setState({
                    data: {
                      ...data,
                      pj_telPrin: value,
                    },
                    formErrors: {
                      ...formErrors,
                      pj_telPrin: undefined,
                    },
                  })}
                />

                <FormFeedback className={`d-block ${formErrors.pj_telPrin ? 'visible' : 'invisible'}`}>
                  {formErrors.pj_telPrin}
                </FormFeedback>
              </FormGroup>
            </Col>
          </Row>

          <Row className="mt-1">
            <Col>
              <h6>
                Contatos
              </h6>
            </Col>
          </Row>

          <Row>
            <Col>
              <hr style={{ marginTop: 0, paddingTop: 0 }} />
            </Col>
          </Row>

          {stakeholders?.length > 0 && stakeholders.map((stakeholder, index) => (
            <Row key={stakeholder.id}>
              <Col xs={12} sm={6} lg={3}>
                <FormGroup>
                  <Label>
                    Nome
                  </Label>

                  <AsyncCreatableSelect
                    cacheOptions
                    isSearchable
                    isClearable={false}
                    isMulti={false}
                    defaultOptions={[]}
                    noOptionsMessage={() => 'Digite para buscar'}
                    loadingMessage={() => 'Carregando...'}
                    formatCreateLabel={userInput => `Adicionar "${userInput}"`}
                    getOptionValue={option => option.pf_id}
                    getOptionLabel={option => option.pf_nomeExibicao}
                    getNewOptionData={(inputValue, optionLabel) => ({
                      pf_id: inputValue,
                      pf_nomeExibicao: optionLabel,
                      __isNew__: true,
                    })}
                    value={stakeholder.pf_nomeExibicao}
                    loadOptions={async query => {
                      try {
                        const res = await oikosApi.get('/', {
                          action: 'get',
                          table: 'pf',
                        })

                        console.tron.log('res', res)

                        const regex = new RegExp(query, 'i')
                        const filtered = res.data.filter(i => regex.test(i.pf_nomeExibicao))
                        return filtered
                      } catch (e) {
                        return console.tron.log('erro ao buscar pf no cadastro de contratante', e)
                      }
                    }}
                    onChange={e => {
                      stakeholders[index].pf_nomeExibicao = e || null
                      stakeholders[index].email = e.pf_emailProf || null
                      stakeholders[index].phone = e.pf_celProf || e.pf_telFixoProf || null
                      stakeholders[index].isAlrealdyCreated = true
                      this.setState({ stakeholders })
                    }}
                    onCreateOption={e => {
                      stakeholders[index].pf_nomeExibicao = {
                        pf_id: e,
                        pf_nomeExibicao: e,
                      }
                      stakeholders[index].email = null
                      stakeholders[index].phone = null
                      stakeholders[index].isAlrealdyCreated = false
                      this.setState({ stakeholders })
                    }}
                  />
                </FormGroup>
              </Col>

              <Col xs={12} sm={6} lg={3}>
                <FormGroup>
                  <Label>
                    Função
                  </Label>

                  <AsyncSelect
                    cacheOptions
                    defaultOptions
                    isSearchable={false}
                    isClearable
                    isMulti={false}
                    getOptionValue={option => option.papel_id}
                    getOptionLabel={option => option.papel_nome}
                    value={stakeholder.papel_id || null}
                    loadOptions={async () => {
                      try {
                        const res = await oikosApi.get('/', {
                          action: 'get',
                          table: 'papel',
                        })

                        if (stakeholder.papel_id !== undefined) {
                          stakeholders[index] = {
                            ...stakeholders[index],
                            papel_id: res.data.find(i => i.papel_id === stakeholder.papel_id),
                          }
                          this.setState({ stakeholders })
                        }

                        return res.data
                      } catch (e) {
                        return notifyError(e)
                      }
                    }}
                    onChange={e => {
                      stakeholders[index] = {
                        ...stakeholders[index],
                        papel_id: e || undefined,
                      }
                      this.setState({ stakeholders })
                    }}
                  />
                </FormGroup>
              </Col>

              <Col xs={12} sm={6} lg={3}>
                <FormGroup>
                  <Label>
                    E-mail
                  </Label>

                  <Input
                    disabled={stakeholder.isAlrealdyCreated}
                    value={stakeholder.email}
                    onChange={e => {
                      stakeholders[index] = {
                        ...stakeholders[index],
                        email: e.target.value || null,
                      }
                      return this.setState({ stakeholders })
                    }}
                  />
                </FormGroup>
              </Col>

              <Col xs={12} sm={6} lg={3}>
                <FormGroup>
                  <Label>
                    Telefone
                  </Label>

                  <div className="d-flex">
                    <MaskedInput
                      unmask
                      mask="(00) 00000-0000"
                      lazy={false}
                      disabled={stakeholder.isAlrealdyCreated}
                      value={stakeholder.phone}
                      onAccept={value => {
                        stakeholders[index] = {
                          ...stakeholders[index],
                          phone: value || null,
                        }
                        return this.setState({ stakeholders })
                      }}
                    />

                    <Button
                      className="ml-3"
                      size="sm"
                      color="light"
                      disabled={stakeholders.length <= 1}
                      onClick={() => this.setState({
                        stakeholders: stakeholders.filter((item) => item.id !== stakeholder.id),
                      })}
                    >
                      <i className="ri-delete-bin-6-line align-middle font-size-16" />
                    </Button>
                  </div>
                </FormGroup>
              </Col>
            </Row>
          ))}

          <Row>
            <Col>
              <Button
                size="sm"
                color="light"
                onClick={() => {
                  stakeholders.push({ id: uuid() })
                  this.setState({ stakeholders })
                }}
              >
                <i className="ri-add-fill align-middle font-size-18" />
              </Button>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            color="light"
            className="waves-effect"
            onClick={toggle}
            disabled={handleFormSubmitIsLoading}
          >
            Cancelar
          </Button>
          <Button
            type="button"
            color="primary"
            className="waves-effect waves-light"
            onClick={() => this.handleSubmit()}
            disabled={
              handleFormSubmitIsLoading
              || !data.pj_cnpj || !data.pj_nomefanta || !data.pj_razaosocial
              || !data.pais_id || !data.pj_endLogr || !data.pj_endNum
            }
          >
            Adicionar
            {(handleFormSubmitIsLoading) && (
              <Spinner size="sm" className="ml-2" />
            )}
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}
